import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'select',
        name: 'zoneType',
        title: i18n.t('account.zone.type'),
        rules: {required: true},
        options: {
            data: [],
            label: 'name',
            track: 'id'
        },
        modal: ['zone_type_id'],
        data: ['zone_type'],
        additionalButton: {
            icon: 'plus',
            variant: 'primary',
            size: 'sm',
            title: i18n.t('general.add'),
            type: 'Defination',
        },
        checkBox: false
    },
    {
        type: 'text',
        name: 'zone_no',
        title: i18n.t('account.zone.no'),
        rules: {required: true, numeric: true},
        options: false,
        modal: ['zone_no'],
        data: ['zone_no',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'name',
        title: i18n.t('account.zone.name'),
        rules: {required: true},
        options: false,
        modal: ['name'],
        data: ['name',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'service_time',
        title: i18n.t('account.zone.serviceTime'),
        rules: {required: true, numeric: true},
        options: false,
        modal: ['service_time'],
        data: ['service_time',],
        additionalButton: false,
        checkBox: {
            name: 'is_service',
            modal: ['is_service'],
            data: ['is_service']
        }
    },
    
 
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/Alarmsis/Account/forms/zoneForms.js